import axios from "axios";
import * as Sentry from "@sentry/react";
import Cookies from "js-cookie";
import { decodeJwt } from "jose";
import { IToken } from "../types/auth";

export const defineToken = (token: string) => {
  Cookies.set('token', token, { secure: true, sameSite: 'Lax' } );
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const tokenValues = decodeJwt<IToken>(token);
  Cookies.set("lang", tokenValues.locale);
  Sentry.setUser(tokenValues);
  return tokenValues;
}

export const undefineToken = () => {
  Cookies.remove('token');
  axios.defaults.headers.common["Authorization"] = "";
}